import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "utils/api";

interface Respondent {
  id: number;
  firstName: string;
  lastName: string;
}

interface RespondentsSlice {
  isLoading: boolean;
  respondents: Respondent[];
  error: string;
}

const initialState: RespondentsSlice = {
  isLoading: false,
  respondents: [],
  error: "",
};

export const getRespondents = createAsyncThunk(
  "getRespondents",
  async (id: number) => {
    try {
      const response = await axiosInstance.get(
        `/v1/boards/${id}/respondents`
      );
      return response.data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);
export const respondentsSlice = createSlice({
  initialState,
  name: "respondents",
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRespondents.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getRespondents.fulfilled, (state, action) => {
        state.isLoading = false;
        state.respondents = action.payload;
      })
      .addCase(getRespondents.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message as string;
      });
  },
});
